module.exports = __webpack_public_path__ + "img/thumb_image12.606e8b75.jpg";